
import React, { useContext } from 'react'
import classnames from 'classnames'

import { useThemeContext } from '../../contexts/ThemeProvider'
import HeaderLogo from '../Logos/HeaderLogo'
import UserBox from './UserBox'

const ApplicationHeader = () =>
{
	const [controller, dispatch] = useThemeContext()
	const { headerBackgroundColor, enableHeaderShadow, enableMobileMenuSmall } = controller
	
	return (
		<div
			className={ classnames("app-header", headerBackgroundColor, { "header-shadow": enableHeaderShadow, }) }
		>
			<HeaderLogo />
			<div className={ classnames("app-header__content", { "header-mobile-open": enableMobileMenuSmall, }) }>
				<div className="app-header-left">
					{/*<SearchBox />*/}
					{/*<MegaMenu />*/}
				</div>
				<div className="app-header-right">
					{/*<HeaderDots />*/}
					<UserBox />
				</div>
			</div>
		</div>
	)
}

export default ApplicationHeader
